export default "__VITE_ASSET__DFxPK9E8__"